import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReportingService } from 'src/app/services/reporting/reporting.service';
import { ResponseTimeService } from 'src/app/services/general/response-time.service';
import { IQuestionFactSummary } from 'src/app/interfaces/iquestion-fact-summary';
import { ICallOverview } from 'src/app/interfaces/icall-overview';
import { TranslationService } from 'src/app/services/translation.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
  selector: 'app-reporting-content',
  templateUrl: './reporting-content.component.html',
  styleUrls: ['./reporting-content.component.scss'],
  standalone: false,
  providers: [
      {
        provide: TRANSLOCO_SCOPE,
        useValue: 'reporting',
      },
    ],
})
export class ReportingContentComponent {
  @Input() accountUuid: string = '';
  @Input() moduleUuid: string = '';
  @Input() moduleName: string = '';
  @Input() callTypesInModule: string = '';
  @Output() resultFetched: EventEmitter<boolean> = new EventEmitter<boolean>();
  isContentLoading: boolean = true;
  questionFactSummary: IQuestionFactSummary | undefined;
  isSidePaneVisible: boolean = false;
  selectedCall: ICallOverview | undefined;
  totalScore: number = 5;
  isMsgAdherence: boolean = false;

  constructor(
    private reportingService: ReportingService,
    private responseTimeService: ResponseTimeService,
    private translationService: TranslationService,
  ) { }

  ngOnInit() {
    this.translationService.loadScopedTranslation('reporting');
    this.getModuleQuestionAndFactSummary();
  }

  getModuleQuestionAndFactSummary() {
    this.responseTimeService
      .logResponseTime(
        this.reportingService.getModuleSummaryCards(this.accountUuid, this.moduleUuid, this.callTypesInModule),
        'getModuleQuestionAndFactSummary'
      )
      .subscribe({
        next: (res: IQuestionFactSummary) => {
          if (this.isObjectNotEmpty(res)) {
            this.updateCallNames(res);
          }
          this.questionFactSummary = res;
          if (this.callTypesInModule === 'CONVERSATIONAL' && (this.questionFactSummary.LEAST_ARTICULATED_MESSAGE || this.questionFactSummary.MOST_ARTICULATED_MESSAGE)) {
            this.isMsgAdherence = true;
          }
          this.isContentLoading = false;
          this.resultFetched.emit(true);
        },
        error: (error) => {
          this.resultFetched.emit(true);
          this.isContentLoading = false;
          console.error('Error fetching questions and fact summary', error);
        },
      });
  }

  isObjectNotEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length > 0;
  }

  updateCallNames(obj: any) {
    ['HIGHEST_SCORING_OBJECTIVE', 'LOWEST_SCORING_OBJECTIVE'].forEach(key => {
      if (obj[key] && obj[key].callName && obj[key].callName.includes('|')) {
        const callNames = obj[key].callName.split('|').map((name: string) => name.trim());
        obj[key].callNames = callNames;
        obj[key].numberOfCalls = callNames.length;
      }
    });
  }
}
